/* IM8 Aryna — shared FX for split sections.
   Document-wide scroll-reveal + live servings count. Runs once (guarded).
   The product 3D/WebGL glow lives in its own showcase section, not here. */
(function () {
  if (window.__im8ArFx) return;
  window.__im8ArFx = 1;

  function init() {
    /* ---- scroll reveal ---- */
    try {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
      if (('IntersectionObserver' in window) && !reduce) {
        document.querySelectorAll('.ar-lp').forEach(function (r) { r.classList.add('ar-anim'); });
        var sels = ['.ar-intro p', '.ar-reason__head', '.ar-reason h2', '.ar-img', '.ar-collage', '.ar-reason .ar-p', '.ar-quote', '.ar-stat', '.ar-bridge', '.ar-pill', '.ar-roster__head', '.ar-amb', '.ar-show__head', '.ar-show__img', '.ar-show__stat', '.ar-foryou__head', '.ar-foryou__col', '.ar-clin__head', '.ar-clin__card', '.ar-proof__grid > div', '.ar-closing > div > *'];
        var els = [];
        sels.forEach(function (s) { document.querySelectorAll(s).forEach(function (n) { els.push(n); }); });
        els.forEach(function (e) { e.classList.add('ar-reveal'); });
        var grids = ['.ar-foryou__grid', '.ar-roster__grid', '.ar-clin__grid', '.ar-proof__grid', '.ar-show__stats'];
        grids.forEach(function (g) {
          document.querySelectorAll(g).forEach(function (gn) {
            var kids = gn.children;
            for (var k = 0; k < kids.length; k++) {
              if (kids[k].classList && kids[k].classList.contains('ar-reveal')) kids[k].style.transitionDelay = (k * 70) + 'ms';
            }
          });
        });
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('ar-in'); io.unobserve(x.target); } });
        }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
        els.forEach(function (e) { io.observe(e); });
        setTimeout(function () { els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight) e.classList.add('ar-in'); }); }, 1200);
      }
    } catch (e) {}

    /* ---- live servings (shared homepage source) ---- */
    try {
      if (!window.im8OrderData) {
        var api = 'https://im8-order-count.vercel.app/api/exact-order-count';
        window.im8OrderData = new Promise(function (res) {
          var c = new AbortController();
          setTimeout(function () { c.abort(); }, 2500);
          fetch(api + '?maxAgeMinutes=1440', { signal: c.signal }).then(function (r) { return r.json(); }).then(function (d) { res(d && d.status === 'COMPLETED' && isFinite(d.exactOrders) ? d.exactOrders : null); }).catch(function () { res(null); });
        });
      }
      window.im8OrderData.then(function (orders) {
        if (!orders || !isFinite(orders)) return;
        var serv = Math.round(orders * 50.88 / 1000000) + 'M';
        document.querySelectorAll('[data-ar-live="servings"]').forEach(function (e) { e.textContent = serv; });
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
